var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Model from './Model';
import { observable, computed } from 'mobx';
import ServiceEntryStatus from '../data/ServiceEntryStatus';
/**
 *
 */
var ServiceEntryModel = /** @class */ (function (_super) {
    __extends(ServiceEntryModel, _super);
    /**
     *
     * @param data
     */
    function ServiceEntryModel(data) {
        return _super.call(this, data) || this;
    }
    ServiceEntryModel.prototype.initialize = function (data) {
        this.priority = 0;
        this.tags = [];
        this.labels = [];
    };
    Object.defineProperty(ServiceEntryModel.prototype, "originatingTriggerValueAsDate", {
        /**
         *
         * @return {Date}
         */
        get: function () {
            return new Date(this.originatingTriggerValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "originatingTriggerReminderBeforeValueAsDate", {
        /**
         *
         * @return {Date}
         */
        get: function () {
            return new Date(this.originatingTriggerReminderBeforeValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "assetValueOnCloseAsDate", {
        /**
         *
         * @return {Date}
         */
        get: function () {
            return new Date(this.assetValueOnClose);
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param data
     */
    ServiceEntryModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'dueDateTimeUtc':
                case 'creationDateTimeUtc':
                case 'lastModifiedDateTimeUtc':
                case 'scheduledDateTimeUtc':
                case 'closeDateTimeUtc':
                case 'timestamp':
                    _this[key] = data[key] ? new Date(data[key]) : null;
                    break;
                case 'dueDateTimestamp':
                    _this['dueDateTimeUtc'] = data[key] ? new Date(data[key]) : null;
                    break;
                default:
                    _this[key] = data[key];
            }
        });
    };
    Object.defineProperty(ServiceEntryModel.prototype, "labelFilterArray", {
        /**
         *
         * @return {*[]}
         */
        get: function () {
            return this.labels.map(function (label) {
                return label.name;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "labelSortString", {
        get: function () {
            return this.labelFilterArray.sort().join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "filterString", {
        /**
         *
         * @return {string}
         */
        get: function () {
            var _this = this;
            var s = '';
            var keys = Object.keys(this);
            // Attributes
            keys.map(function (key) {
                switch (key) {
                    case 'labels':
                        // Parse labels
                        _this.labels.map(function (data) {
                            s += data.name + '\n';
                        });
                        break;
                    case 'tags':
                        _this[key].map(function (tagObject) {
                            s += tagObject.tagName + '\n';
                        });
                        break;
                    default:
                        s += _this[key] + '\n';
                }
            });
            // Add location string of assetModel too
            if (this.assetModel && this.assetModel.properties.place) {
                s += this.assetModel.properties.place + '\n';
            }
            return s.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "calculatedStatus", {
        /**
         *
         * @return {string|*}
         */
        get: function () {
            var status;
            if (this.status !== ServiceEntryStatus.Closed && this.scheduledDateTimeUtc) {
                status = ServiceEntryStatus.InProgress;
            }
            else {
                status = this.status;
            }
            if (this.assetModel) {
                this.assetModel.properties.serviceStatus = status;
            }
            return status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "canSetInProgress", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.calculatedStatus === ServiceEntryStatus.Created;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceEntryModel.prototype, "canUpdate", {
        /*
         *
         */
        get: function () {
            return this.calculatedStatus !== ServiceEntryStatus.Created;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "serviceEntryId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "assetId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "assetEquipmentId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "cumulativeOperatingHoursDurationInHours", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "schemaId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "name", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "description", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "operatorName", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "assignedTo", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "resolution", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "triggerIntervalValueType", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "triggerType", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "createdByUserId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "lastModifiedByUserId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "closedByUserId", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "closeDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "creationDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "dueDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "lastModifiedDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "scheduledDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "originatingTriggerValue", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "originatingTriggerIntervalValue", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "originatingTriggerReminderBeforeValue", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "assetValueOnClose", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "assetValueOnCreation", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "timestamp", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "status", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "priority", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "tags", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "assetModel", void 0);
    __decorate([
        observable
    ], ServiceEntryModel.prototype, "labels", void 0);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "originatingTriggerValueAsDate", null);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "originatingTriggerReminderBeforeValueAsDate", null);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "assetValueOnCloseAsDate", null);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "filterString", null);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "calculatedStatus", null);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "canSetInProgress", null);
    __decorate([
        computed
    ], ServiceEntryModel.prototype, "canUpdate", null);
    return ServiceEntryModel;
}(Model));
export default ServiceEntryModel;
